import { ErrorMessages, Rule } from '@ubud/form';

export class RegisterInstitutionCommunityRule extends Rule {
    public get errorMessages(): ErrorMessages {
        return {

        };
    }

    public getFormControls(): { [p: string]: any } {
        return {
            license_number: [''],
            license_file: [''],
            tax_number: [''],
            tax_file: [''],
            pic_identity_number: [''],
        };
    }
}



// WEBPACK FOOTER //
// ./src/lemsar/auth/rules/register-institution-community.rule.ts